import stackBindVueComponent from './vue-components/helpers/mountVueComponent.js'
import EventListing from './vue-components/event-listing/events.vue'

stackBindVueComponent(EventListing.placeholderId, EventListing)
